import { useCallback, useEffect } from "react";
import "./FaqEditorial.css";
import contact_page_banner from "../../assets/faq/faq_editorial_banner.png"; // replace with your image path
import { useDispatch, useSelector } from "react-redux";
import { hideFaq, setfaqData, showHeroBanner, showSingleFAQ } from "../../features/serviceSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";


const FaqEditorial = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        faq_data
    } = useSelector(state => state.service);
    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_CUSTOM_API+"/faqs"
            );
            dispatch(setfaqData(response.data));

        } catch (error) {
            console.error("API error:", error);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <section className="faq-editorial">
                {/* Vertical Labels */}

                <div className="quick-label">
                    <button
                        type="button"
                        className="faq-close-btn"
                        onClick={(event) => {
                            event.stopPropagation();
                            dispatch(hideFaq());
                            dispatch(showHeroBanner());
                            navigate("/services");
                        }}
                    >
                        &#10005; Close
                    </button>
                    <p>QUICK LINKS</p>
                    <div className="faq-top">
                        <ul className="quick-links">
                            <li>SEASONAL SERVICES</li>
                            <li>TEXTILE CARE GUIDES</li>
                            <li>FIND A BOUTIQUE</li>
                            <li>BOOK AN APPOINTMENT</li>
                        </ul>
                    </div>
                </div>
                <div>
                    {/* Top Links */}
                    <div className="faq-top">
                        <ul className="quick-links">
                            <li>SEASONAL SERVICES</li>
                            <li>TEXTILE CARE GUIDES</li>
                            <li>FIND A BOUTIQUE</li>
                            <li>BOOK AN APPOINTMENT</li>
                        </ul>
                    </div>


                    {/* Hero */}
                    <div className="faq-hero">
                        <img src={contact_page_banner} alt="FAQ Hero" />
                        <h2>
                            Frequently<br />
                            Asked<br />
                            <span>Questions</span>
                        </h2>
                    </div>

                    {/* Cards Grid */}
                    <div className="faq-grid">
                        {faq_data?.categories?.map((x) => {
                            return (
                                <div className="faq-card" key={x.category_id} onClick={() => {
                                    dispatch(hideFaq())
                                    dispatch(showSingleFAQ(x.category_id))
                                }}>
                                    <div className="icon"><img src={x.logo_image} alt="" /></div>
                                    <h3>{x.category_name}<br />FAQS</h3>
                                </div>
                            )
                        })}
                    </div>
                </div>

            </section>
            <aside className="vertical-contact-label side-vertical-heading">
                <span>FAQS</span> <span className="spacer"></span> <span>MEMBERSHIP SERVICES</span>
            </aside>
        </>
    );
};

export default FaqEditorial;
